module.exports = __webpack_public_path__ + "static/media/delay-saving-ken.de08cf7f.webp";